import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { BrandIcon } from '../BrandIcon';
interface WelcomeStepProps {
  onNextStep: () => void;
  onOpenModal: () => void;
}
export const WelcomeStep = ({
  onNextStep,
  onOpenModal
}: WelcomeStepProps) => {
  return <div className="text-center" data-id="element-503">
      <div className="flex flex-col items-center justify-center mb-4" data-id="element-504">
        <BrandIcon width={64} height={64} className="mb-4" data-id="element-505" />
        <h1 className="text-3xl font-bold" data-id="element-506">LaVee - Do it your way.</h1>
      </div>
      <p className="text-xl mb-8" data-id="element-507">
        Let's personalize your experience to help you find the events that match
        your interests.
      </p>
      <img src="https://images.unsplash.com/photo-1546519638-68e109498ffc?q=80&w=2070&auto=format&fit=crop" alt="Sports collage" className="w-full h-48 object-cover rounded-lg mb-8 mx-auto max-w-lg" data-id="element-508" />
      <p className="text-sm text-gray-600 mb-6 max-w-lg mx-auto" data-id="element-509">
        LaVee is a privacy-obsessed service: we don't share your data with
        anyone except how and when <i data-id="element-510">you</i> want to. Right now, this is just
        between us.
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center mb-6" data-id="element-511">
        <button onClick={onOpenModal} className="border-2 border-sky-500 text-sky-600 px-6 py-3 rounded-lg font-medium hover:bg-sky-50 transition-colors" data-id="element-512">
          How does it work?
        </button>
        <button onClick={onNextStep} className="bg-gradient-to-r from-sky-500 to-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:from-sky-600 hover:to-blue-700 transition-colors flex items-center justify-center" data-id="element-513">
          Get Started
          <ArrowRightIcon className="ml-2" size={20} data-id="element-514" />
        </button>
      </div>
      <div className="mt-4" data-id="element-515">
        <Link to="/privacy" className="text-sky-600 hover:underline text-sm" data-id="element-516">
          Read our Privacy Policy
        </Link>
      </div>
    </div>;
};